import {
  Alert,
  Confirm,
  FormMultiSelectAdd,
  GenerateCourseChaptersCards,
} from "@mikros/shared-ui";
import { useEffect, useRef, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ApiServices from "../../service/apiService";
import {
  Card,
  CardInfo,
  Cards,
  CourseChapter,
  CourseModuleCards,
  ManualChapter,
} from "@mikros/library";
import {
  TextArea,
  TextAreaChangeEvent,
  TextBox,
  TextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@progress/kendo-react-buttons";
import S3Service from "../../service/s3Service";
import { Field } from "@progress/kendo-react-form";
import Spinner from "../../utils/Loader";
import Account from "../../utils/apiConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import ErrorHandler from "../../utils/errorConfig";
import { events } from "aws-amplify/api";
import AuthService from "../../service/authService";
import { jwtDecode } from "jwt-decode";
// export interface CoursesProps {}

// export interface EditCourseProps {}

export function EditCourse() {
  const intl = useIntl();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const spinner = new Spinner();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();

  const [updateDialog, setUpdateDialog] = useState<boolean>(false);
  const [particularCourseDetails, setParticularCourseDetails] =
    useState<CourseModuleCards>({
      chapters: [
        {
          cards: [{ cardInfo: { card: [{} as Card] } as CardInfo } as Cards],
        } as CourseChapter,
      ],
    } as CourseModuleCards);
  const [description, setDescription] = useState<string>(
    particularCourseDetails.description
  );
  const [courseName, setCourseName] = useState<string>(
    particularCourseDetails.courseName
  );

  const [sub, setSub] = useState(null);
  const subRef = useRef(null);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  console.log("update dialog print value", updateDialog);
  const toggleUpdateDialog = () => {
    setUpdateDialog(!updateDialog);
  };

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect of edit course", subValue);
    }
    fetchSub();
  }, []);

  const apiGetParticularCourseDetails = async (e: string, tenantId: string) => {
    console.log("This is the tenantId ref", tenantId);
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      await api
        .makeRequest(`${accountInstance.accntId}/course/${e}`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          let x = res as CourseModuleCards;
          x.chapters?.sort((a, b) => a.seqNo - b.seqNo);
          x.chapters?.map((ele) => {
            return ele.cards?.sort((a, b) => a.seqNo - b.seqNo);
          });
          setParticularCourseDetails(x);
          setDescription(x.description);
          setCourseName(x.courseName);

          console.log("This is the course", x);
        });
    }
  };

  const handleUpdateStatusAll = async (
    status: string,
    course?: CourseModuleCards
  ): Promise<boolean> => {
    let chapters: ManualChapter[] = [];
    let thisCrs = particularCourseDetails;
    if (course) {
      thisCrs = course;
    }

    for (let i = 0; i < thisCrs.chapters.length; i++) {
      const courseChapter = thisCrs.chapters[i];
      let manualChapter = {
        chapterName: courseChapter.chapterName,
        courseId: courseChapter.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: courseChapter.description,
        publishedBy: "",
        publishedDate: courseChapter.date,
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        isLastChapter: courseChapter.isLastChapter,
        questions: courseChapter.questions,
      };

      for (let card of manualChapter.cards) {
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(manualChapter);
    }

    const courseBody = {
      courseId: thisCrs.courseId,
      chapter: chapters,
      courseName: courseName,
      description: description,
      status: status,
    };

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          `${accountInstance.accntId}/course/${thisCrs.courseId}/courseUpdStsAll`,
          "POST",
          courseBody
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return false;
          }
          console.log("Manual Course Chapters added in update", res);
          return true;
        })
        .catch((err) => {
          return false;
        });
    } else {
      return false;
    }
  };

  const handleUpdateStatusRev = async (
    status: string,
    course: CourseModuleCards,
    unpublish: boolean
  ): Promise<boolean> => {
    let chapters: ManualChapter[] = [];
    for (let i = 0; i < course.chapters.length; i++) {
      const courseChapter = course.chapters[i];
      let manualChapter = {
        chapterName: courseChapter.chapterName,
        courseId: courseChapter.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: courseChapter.description,
        publishedBy: "",
        publishedDate: courseChapter.date,
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        isLastChapter: courseChapter.isLastChapter,
        questions: courseChapter.questions,
      };

      for (let card of manualChapter.cards) {
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(manualChapter);
    }

    const courseBody = {
      courseId: course.courseId,
      chapter: chapters,
      courseName: courseName,
      description: description,
      status: status,
      unpublish: unpublish,
    };

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          `${accountInstance.accntId}/course/${course.courseId}/courseUpdStsRev`,
          "POST",
          courseBody
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);

            await errorInstance.updateErrorCode(res.errorMessage);

            return false;
          }
          console.log("Manual Course Chapters added in update", res);
          return true;
        })
        .catch((e) => {
          return false;
        });
    } else {
      return false;
    }
  };

  const apigetPresignedUrl = async (courseId: any, filePath: string) => {
    console.log("inside create course api ");
    console.log("inside api,courseId", courseId);
    console.log("inside api,filePath ", filePath);
    let body = {
      filePath: filePath,
    };
    let api = ApiServices.getInstance();

    let apiCall = {} as any;
    if (accountInstance.accntId) {
      apiCall = await api.makeRequest(
        `${accountInstance.accntId}/course/${courseId}`,
        "POST",
        body
      );
    }
    if (apiCall) {
      console.log("api call", apiCall);
      return apiCall;
    }
  };

  const apiUpdateChapters = async (chaptersCards: ManualChapter[]) => {
    const courseBody = {
      courseName: courseName,
      courseId: particularCourseDetails.courseId,
      description: description,
      chapter: chaptersCards,
    };

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          `${accountInstance.accntId}/course/${particularCourseDetails.courseId}`,
          "PUT",
          courseBody
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return false;
          }
          return true;
        })
        .catch((e) => {
          return false;
        });
    } else {
      return false;
    }
  };

  const readerUpload = (e: any) =>
    new Promise<object>((resolve, reject) => {
      const reader = new FileReader();
      let s3 = S3Service.getInstance();
      let element = e.fileName;
      console.log("print file name", element);

      reader.readAsDataURL(element);
      reader.onload = async () => {
        let file = s3.convertToFile(reader.result, element.type, element.name);
        console.log("file reader", file);

        await s3
          .writeFileInFolder(e.filePath, file, "Mikros-Cards", e.fileName.type)
          .then(async (res) => {
            let url = await apigetPresignedUrl(
              particularCourseDetails.courseId,
              e.cardInfo.card[0].url
            );
            resolve(url);
          })
          .catch((e) => {
            // toast.error("Something went wrong");
            <FormattedMessage id="course.readerUploadError"></FormattedMessage>;
            reject(e);
          });
      };
    });

  async function duplicateS3File(
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) {
    let s3 = S3Service.getInstance();
    const sourceKeyPath = sourceKey.split("/").slice(1).join("/");
    const sourceBucket = sourceKey.split("/")[0];

    const destinationKeyPath = destinationKey.split("/").slice(1).join("/");
    const destinationBucket = destinationKey.split("/")[0];
    const fileName = destinationKey.split("/").pop();
    const file = await s3.readFile(sourceKeyPath, sourceBucket);
    const fileData = await fetch(file);
    const blobData = await fileData.blob();
    const uploadablFile = new File([blobData], fileName as string);
    const resp = await s3.writeFileInFolder(
      destinationKeyPath,
      uploadablFile,
      destinationBucket,
      fileType
    );

    const url = await apigetPresignedUrl(
      particularCourseDetails.courseId,
      destinationKey
    );
    console.log("The copied url =>", url);
    return url.url;
  }

  // const handleAudioGeneration = async (e: any): Promise<string | false> => {
  //   console.log("Inside handle audio generation of create course", e);

  //   const body = {
  //     courseId: e.courseId,
  //     chapterId: e.chapterId,
  //     cardId: e.cardId,
  //     accntId: accountInstance.accntId,
  //     createdBy: e.createdBy,
  //     prompt: e.prompt,
  //     cardType: e.cardType,
  //     language: e.language,
  //     languageCode: e.languageCode,
  //     style: e.style,
  //     voiceName: e.voiceName,
  //   };
  //   const accntId = body.accntId;
  //   const courseId = body.courseId;

  //   const endpoint = `${accntId}/course/${courseId}/genAudio`;
  //   const api = ApiServices.getInstance();

  //   if (!accntId) {
  //     return false;
  //   }
  //   try {
  //     const res = await api.makeRequest(endpoint, "POST", body);
  //     if (res && res.errorMessage) {
  //       setErrorFlag(true);
  //       if (errorInstance && errorInstance.updateErrorCode) {
  //         await errorInstance.updateErrorCode(res.errorMessage);
  //       }
  //       console.log("audio error response", res);
  //       return false;
  //     }
  //     console.log("Audio generation API response", res);
  //     const parsedBody = JSON.parse(res.body);
  //     const presignedUrl = parsedBody.presignedUrl;
  //     console.log("Presigned url audio being sent in create", presignedUrl);
  //     return presignedUrl;
  //   } catch (err) {
  //     console.error("Error in handle audio gen", err);
  //     setErrorFlag(true);
  //     if (errorInstance && errorInstance.updateErrorCode) {
  //       await errorInstance.updateErrorCode("Audio gen failed");
  //     }
  //     return false;
  //   }
  // };

  const handleAudioGeneration = async (
    e: any
  ): Promise<{ presignedUrl: string; prompt: string } | false> => {
    console.log("Inside handle audio generation of create course", e);
  
    const body = {
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      cardType: e.cardType,
      language: e.language,
      languageCode: e.languageCode,
      style: e.style,
      voiceName: e.voiceName,
    };
    const accntId = body.accntId;
    const courseId = body.courseId;
  
    const endpoint = `${accntId}/course/${courseId}/genAudio`;
    const api = ApiServices.getInstance();
  
    if (!accntId) {
      return false;
    }
    try {
      const res = await api.makeRequest(endpoint, "POST", body);
      if (res && res.errorMessage) {
        setErrorFlag(true);
        if (errorInstance && errorInstance.updateErrorCode) {
          await errorInstance.updateErrorCode(res.errorMessage);
        }
        console.log("audio error response", res);
        return false;
      }
      console.log("Audio generation API response", res);
      const parsedBody = JSON.parse(res.body);
  
      const presignedUrl = parsedBody.presignedUrl;
      const prompt = parsedBody.prompt; // extract prompt
  
      console.log("Prompt returned in create", prompt);
      console.log("Presigned url audio being sent in create", presignedUrl);
  
  
      return { presignedUrl, prompt };
    } catch (err) {
      console.error("Error in handle audio gen", err);
      setErrorFlag(true);
      if (errorInstance && errorInstance.updateErrorCode) {
        await errorInstance.updateErrorCode("Audio gen failed");
      }
      return false;
    }
  };


  const handleImageGeneration = async (e: any): Promise<string | false> => {
    console.log("inside handle image generation of edit course", e);

    const body = {
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      cardType: e.cardType,
    };

    const accntId = body.accntId;
    const courseId = body.courseId;
    // const endpoint = `${accntId}/course/${courseId}/genMedia`;
    const endpoint = `${accntId}/course/${courseId}/genImage`;
    const api = ApiServices.getInstance();

    if (!accntId) return false;

    const channelPath = `/default/${body.cardId}`;
    // setLoading(true);
    // spinner.showSpinner();

    try {
      console.log("Connecting to:", channelPath);
      const channel = await events.connect(channelPath);
      console.log("Connected to channel:", channel);

      const presignedUrl: string = await new Promise((resolve, reject) => {
        channel.subscribe({
          next: (data) => {
            console.log("Received data from channel subscription", data);
            try {
              // ONLY parse if it’s still a JSON string
              const eventData =
                typeof data.event === "string"
                  ? JSON.parse(data.event)
                  : data.event;

              const url = eventData?.presignedUrl;
              if (!url) throw new Error("presignedUrl missing");

              console.log("Presigned URL:", url);
              resolve(url);
            } catch (err) {
              reject("Failed to extract presignedUrl: " + err);
            }
          },
          error: (err) => {
            console.error("Error in channel subscription", err);
            // setLoading(false);
            // spinner.hideSpinner();
            reject("Channel subscription error");
          },
        });

        console.log(
          "Subscribed to channel. Now sending video generation request..."
        );

        // Fire API after subscription starts listening
        api.makeRequest(endpoint, "POST", body).then((res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            if (errorInstance && errorInstance.updateErrorCode) {
              errorInstance.updateErrorCode(res.errorMessage);
            }
            // spinner.hideSpinner();
            // setLoading(false);
            reject("API returned error");
          }
          console.log("Image generation API response:", res);
        });
      });
      // setLoading(false);
      // spinner.hideSpinner();
      return presignedUrl;
    } catch (err) {
      console.error("Error in handleImageGeneration:", err);
      // spinner.hideSpinner();
      // setLoading(false);
      setErrorFlag(true);
      if (errorInstance && errorInstance.updateErrorCode) {
        await errorInstance.updateErrorCode("Image generation failed");
      }
      return false;
    }
  };

  const handleVideoGeneration = async (e: any): Promise<any> => {
    console.log("inside handle video generation of edit course", e);

    const body = {
      courseName: e.courseName,
      chapterName: e.chapterName,
      courseId: e.courseId,
      chapterId: e.chapterId,
      cardId: e.cardId,
      accntId: accountInstance.accntId,
      createdBy: e.createdBy,
      prompt: e.prompt,
      userId: subRef.current,
      cardType: e.cardType,
    };
    console.log("body in edit course handle video generation", body);

    const accntId = body.accntId;
    const courseId = body.courseId;

    const endpoint = `${accntId}/course/${courseId}/genVideo`;

    const api = ApiServices.getInstance();

    if (accntId) {
      return await api
        .makeRequest(endpoint, "POST", body)
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            if (errorInstance && errorInstance.updateErrorCode) {
              await errorInstance.updateErrorCode(res.errorMessage);
            }
            return false;
          }
          console.log("Video generation response:", res);
          return res;
        })
        .catch(async (err) => {
          setErrorFlag(true);
          if (errorInstance && errorInstance.updateErrorCode) {
            await errorInstance.updateErrorCode("Video generation failed");
          }
          return false;
        });
    } else {
      return false;
    }
  };

  const handleUploadGiveUrl = async (e: any) => {
    let url = {};

    if (
      e.cardType !== "TEXT" &&
      e.cardType !== "LINK" &&
      e.cardType !== "Text"
    ) {
      console.log("inside the type of non-text card");

      const reader = new FileReader();
      console.log("print file name before enter", e?.fileName);
      if (e?.fileName) {
        console.log("inside filename");

        url = await readerUpload(e);

        console.log("This is the url in the coourses", url);

        return url;
      }
    }
  };

  const handleCreateCourseUpdateChapterCards = async (
    course: CourseModuleCards
  ): Promise<boolean> => {
    let chapters: ManualChapter[] = [];
    for (let i = 0; i < course.chapters.length; i++) {
      const courseChapter = course.chapters[i];
      let manualChapter = {
        chapterName: courseChapter.chapterName,
        courseId: courseChapter.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: courseChapter.description,
        publishedBy: "",
        publishedDate: courseChapter.date,
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        isLastChapter: courseChapter.isLastChapter,
        questions: courseChapter.questions,
      };

      for (let card of manualChapter.cards) {
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(manualChapter);
    }

    return await apiUpdateChapters(chapters);
  };

  const apiDeleteParticularCourse = () => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(
          `${accountInstance.accntId}/course/${particularCourseDetails.courseId}`,
          "DELETE"
        )
        .then((res) => {});
    }
  };

  useEffect(() => {
    if (
      particularCourseDetails &&
      particularCourseDetails.status === "ARCHIVED"
    ) {
      setUpdateDialog(true);
    }
  }, [particularCourseDetails]);

  useEffect(() => {
    async function initializeAndUseAccount() {
      await apiGetParticularCourseDetails(
        JSON.parse(location.state).data,
        accountInstance.accntId
      );
      setLoading(false);
      spinner.hideSpinner();
    }
    initializeAndUseAccount();
  }, []);

  // Add a function to trigger the useEffect logic
  const triggerCourseDetailsRefresh = useCallback(async () => {
    await apiGetParticularCourseDetails(
      JSON.parse(location.state).data,
      accountInstance.accntId
    );
    setLoading(false);
    spinner.hideSpinner();
  }, []);

  return (
    <>
      {/* {updateDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description="Do you want to update the course?"
            successText="Yes"
            failureText="No"
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgAlert",
            })}`}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              handleUpdateStatusAll("DRAFT", particularCourseDetails);
              toggleUpdateDialog();
            }}
            onFailure={() => {
              toggleUpdateDialog();
            }}
          />
        </Dialog>
      )} */}
      {loading ? (
        spinner.showSpinner()
      ) : (
        <div className="w-full h-full flex flex-col space-y-5">
          {errorFlag && (
            <Dialog className="errorDialogue">
              <Alert
                description={intl.formatMessage({
                  id: errorInstance.errorCode,
                })}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  setErrorFlag(false);
                  // navigate("/courses");
                }}
              />
            </Dialog>
          )}

          {/* <div className="w-full justify-end items-center">
            <Button
              onClick={() => apiDeleteParticularCourse()}
              themeColor={"primary"}
            >
              {" "}
              {`${intl.formatMessage({
                id: "course.chapter.deleteChapter",
              })}`}{" "}
            </Button>
          </div> */}
          <div className="w-full">
            <div className="font-bold">
              <FormattedMessage id="courses.onClickCourse.courseName" />
            </div>
            <TextBox
              valid={true}
              value={courseName}
              className="w-[30%]"
              disabled={
                particularCourseDetails.status === "PUBLISHED" ? true : false
              }
              onChange={(e: TextBoxChangeEvent) =>
                setCourseName(e.value!!.toString())
              }
            />
          </div>
          <div className="w-full">
            <div className="font-bold">
              <FormattedMessage id="courses.onClickCourse.description" />
            </div>
            <TextArea
              valid={true}
              rows={2}
              cols={80}
              className="w-[60%]"
              value={description}
              disabled={
                particularCourseDetails.status === "PUBLISHED" ? true : false
              }
              onChange={(e: TextAreaChangeEvent) => setDescription(e.value)}
            />
          </div>

          <div>
            <Field
              name={"tags"}
              id={"tags"}
              label={
                <strong>
                  <FormattedMessage id="courses.createCourse.tags" />
                </strong>
              }
              component={FormMultiSelectAdd}
              className="bg-white"
              // data={["AI", "Testing", "Deployment", "Tech", "Android"]}
              data={[
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.AI",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Testing",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Deployment",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Tech",
                }),
                intl.formatMessage({
                  id: "courses.pdfGeneratvieAi.Android",
                }),
              ]}
            />
          </div>

          <GenerateCourseChaptersCards
            isManual={true}
            isCourse={true}
            duplicateS3File={(
              sourceKey: string,
              destinationKey: string,
              fileType: string
            ) => {
              return duplicateS3File(sourceKey, destinationKey, fileType);
            }}
            specificCreateCourseFunction={(
              course: CourseModuleCards
            ): Promise<boolean> => {
              return handleCreateCourseUpdateChapterCards(course);
            }}
            cards={particularCourseDetails}
            handleUploadGiveUrl={(e: CourseModuleCards) => {
              return handleUploadGiveUrl(e);
            }}
            handleVideoGeneration={(e: any) => {
              return handleVideoGeneration(e);
            }}
            handleImageGeneration={(e: any) => {
              return handleImageGeneration(e);
            }}
            handleAudioGeneration={(e:any)=>{
              return handleAudioGeneration(e)
            }}
            tenantRole={accountInstance.accntRole}
            handleUpdateStatusRev={(
              status: string,
              course: CourseModuleCards,
              unpublish?: boolean
            ): Promise<boolean> => {
              return handleUpdateStatusRev(status, course, unpublish!!);
            }}
            handleUpdateStatusAll={(
              status: string,
              course: CourseModuleCards
            ): Promise<boolean> => {
              return handleUpdateStatusAll(status, course);
            }}
            onCourseDetailsRefresh={triggerCourseDetailsRefresh}
          />
        </div>
      )}
    </>
  );
}
